/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import Grid from "@mui/material/Grid";
import React from "react";
import iconHeadlineStyle from "./iconHeadlineStyle";
import { Box } from "@mui/material";
import { IconProps } from "../../../../types/IconProps";

type IconHeadlineProps = {
  IconImage: React.ComponentType<IconProps>;
  headlineText?: string;
};

const IconHeadline = ({ IconImage, headlineText }: IconHeadlineProps) => {
  return (
    <Grid container justifyContent={"center"} sx={iconHeadlineStyle.headlineContainer}>
      <Grid item xs={12} sm={6}>
        <Grid container alignItems={"center"}>
          <Grid item xs={3}>
            <Box sx={iconHeadlineStyle.image}>
              <IconImage />
            </Box>
          </Grid>
          <Grid item xs={9}>
            <Box sx={iconHeadlineStyle.contentName}>{headlineText}</Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default IconHeadline;
